import { ValueOf } from 'type-fest';
import type { Link } from '../link/link.types';

export const types = {
  error: 'error',
  info: 'info',
  success: 'success',
  warning: 'warning',
  neutral: 'neutral',
};

export type Message = {
  closeLabel?: string;
  debugInfo?: string;
  header?: string;
  link?: Link;
  showClose?: boolean;
  showIcon?: boolean;
  text: string;
  type?: ValueOf<typeof types>;
  onClose?: () => void;
};
